
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ErrorDetailModal(props) {
  const {
    visible,
    onDiscardHandler,
    children,
    headerTitle,
  } = props;
  const { t } = useTranslation();
  return (
    <Modal show={visible} onHide={onDiscardHandler} className="sisde-modal">
      <Modal.Header>
        <Modal.Title>{headerTitle || t('Error Details')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onDiscardHandler}>
          {t('Close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorDetailModal;
